
const SET_PATIENT = (state, payload) => {
  state.patient = payload
}

const SET_ATTACHMENT = (state, payload) => {
  state.attachment = payload
}

export default {
  SET_PATIENT,
  SET_ATTACHMENT
}



// WEBPACK FOOTER //
// ./src/store/modules/patient/mutations.js